export default __webpack_public_path__ + "static/media/pic6.a2b89241.jpg";